<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>Promo bar</h1>
      <v-layout class="layout--controls">
        <v-btn
          color="primary"
          type="button"
          class="button--top control"
          @click="addPromoBar()"
        >Přidat promo bar</v-btn>
      </v-layout>

      <v-layout class="table-items">
        <v-data-table
          locale="cs"
          :headers="headers"
          :items="items"
          :loading="!loaded"
          item-key="id"
          :items-per-page="perPage"
          :options.sync="options"
          :server-items-length="total"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr
                v-for="item in props.items"
                :key="item.id"
                style="cursor: pointer;"
                @click="goToDetail(item)"
              >
                <td>{{ item.id }}</td>
                <td>{{ item.text }}</td>
                <td>{{ item.url || '—' }}</td>
                <td>{{ formatDate(item.valid_from) }}</td>
                <td>{{ formatDate(item.valid_to) }}</td>
                <td>
                  <span v-if="item.is_active" class="status status--success">ANO</span>
                  <span v-else class="status status--error">NE</span>
                </td>
                <td class="right" style="white-space: nowrap;" @click.stop>
                  <v-btn color="primary" class="button--small mr-1" @click="goToDetail(item)">Detail</v-btn>
                  <v-btn color="error" class="button--small" @click="openDelete(item)">Smazat</v-btn>
                </td>
              </tr>
              <div v-if="props.items.length === 0" class="text-no-results">
                <p>Žádný promo bar nebyl nalezen</p>
              </div>
            </tbody>
          </template>

          <template slot="footer" slot-scope="totals">
            <div class="table-footer" v-bind:class="{'footer--no-results': totals.props.pagination.pageStop === 0}">
              <div class="table-footer__text">Počet položek na stránce</div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0">
                  <span class="table-footer__pages-bold">{{ totals.props.pagination.pageStart + 1 }}-{{ totals.props.pagination.pageStop }}</span>
                  z {{ totals.props.pagination.itemsLength }}
                </span>
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>

      <!-- Potvrzovací dialog -->
      <v-dialog v-model="confirmDelete" max-width="400">
        <v-card>
          <v-card-title>Smazat promo bar?</v-card-title>
          <v-card-text v-if="deleteTarget">„{{ deleteTarget.text }}" bude trvale smazán.</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="confirmDelete = false">Zrušit</v-btn>
            <v-btn color="error" @click="deleteItem()">Smazat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import { debounce, isEqual } from 'lodash';

export default {
  name: 'PromoBar',
  data() {
    return {
      loaded: false,
      confirmDelete: false,
      deleteTarget: null,
      options: {},
      total: 0,
      perPage: 30,
      lastParams: null,
      headers: [
        { text: 'ID', value: 'id', align: 'left' },
        { text: 'Text', value: 'text', align: 'left' },
        { text: 'URL', value: 'url', align: 'left' },
        { text: 'Platnost od', value: 'valid_from', align: 'left' },
        { text: 'Platnost do', value: 'valid_to', align: 'left' },
        { text: 'Aktivní', value: 'is_active', align: 'left' },
        { text: '', value: 'controls', align: 'right', sortable: false },
      ],
      items: [],
    };
  },
  computed: {
    ...mapState(['profile']),
  },
  watch: {
    options: {
      immediate: true,
      handler: debounce(function () {
        const params = this.buildParams();
        if (isEqual(params, this.lastParams)) return;
        this.lastParams = { ...params };
        this.fetchData(params);
      }, 200),
      deep: true,
    },
  },
  methods: {
    addPromoBar() {
      this.$router.push({ name: 'PromoBarDetail', params: { id: 'add' } });
    },
    goToDetail(item) {
      this.$router.push({ name: 'PromoBarDetail', params: { id: item.id } });
    },
    formatDate(date) {
      return date ? moment(date).format('D.M.YYYY HH:mm') : '—';
    },
    buildParams() {
      const params = {};
      if (this.options.page) params.page = this.options.page;
      if (this.options.itemsPerPage) params.per_page = this.options.itemsPerPage;
      if (this.options.sortBy && this.options.sortBy.length > 0) params.sortBy = this.options.sortBy[0];
      if (this.options.sortDesc && this.options.sortDesc.length > 0) params.order = this.options.sortDesc[0] ? 'DESC' : 'ASC';
      return params;
    },
    openDelete(item) {
      this.deleteTarget = item;
      this.confirmDelete = true;
    },
    deleteItem() {
      if (!this.deleteTarget) return;
      this.$axios.delete(`/admin/promo-bars/${this.deleteTarget.id}/delete`).then(() => {
        this.items = this.items.filter(i => i.id !== this.deleteTarget.id);
        this.total -= 1;
      }).catch(() => {
        // selhání – seznam zůstane beze změny
      }).finally(() => {
        this.confirmDelete = false;
        this.deleteTarget = null;
      });
    },
    fetchData(params) {
      this.loaded = false;
      this.$axios.get('/admin/promo-bars', { params }).then((response) => {
        this.items = response.data.promo_bars;
        this.total = response.data.count;
        this.loaded = true;
      }).catch(() => {
        this.loaded = true;
      });
    },
  },
};
</script>

<style lang="scss"></style>

